<template>
  <b-container>
    <h1>Company</h1>

    <b-alert variant="danger" :show="error != ''">{{ error }}</b-alert>
    
    <b-row>
      <b-col md="6">
        <b-button v-if="$store.getters.inRole('Admin')" to="/company/add" variant="primary">Add</b-button>
        
        <b-table-lite class="mt-2" :fields="fields" :items="companies">
          <template v-slot:cell(actions)="data">
            <div class="float-right">
            <b-button size="sm" variant="outline-secondary" class="mr-2" :to="`/company/${data.item.id}`">
              <b-icon-card-text></b-icon-card-text>
            </b-button>
            <b-button v-if="$store.getters.inRole('Admin')" size="sm" variant="outline-secondary" @click="showDeleteDlg(data.item)"><b-icon-trash></b-icon-trash></b-button>
            </div>
          </template>
        </b-table-lite>
      </b-col>
    </b-row>

    <b-modal 
      title="Confirm Delete" 
      v-model="deleteDialog"
      ok-variant="danger"
      ok-title="Delete"
      cancel-variant="outline-secondary"
      @ok="deleteCompany"
    >
      <p>Delete {{ deleteItem.name }}?</p>
    </b-modal>
  </b-container>
</template>
<script>import axios from 'axios';

export default {
  data() {
    return {
      fields: ['name', { key: 'actions', label: '' }],
      companies: [],
      deleteDialog: false,
      deleteItem: {},
      error: ''
    }
  },
  methods: {
    showDeleteDlg(item) {
      this.error = '';
      this.deleteItem = item;
      this.deleteDialog = true;
    },
    deleteCompany() {
      axios.delete(`/api/companies/${this.deleteItem.id}`)
      .then(() => {
        const index = this.companies.indexOf(this.deleteItem);
        if (index > -1) {
          this.companies.splice(index, 1);
        }
      })
      .catch(() => {
        this.error = 'Failed to delete company.'
      })
    }
  },
  created() {
    axios.get('/api/companies')
      .then( response => {
        this.companies = response.data
      }).catch(error => {
        console.log(error);
      })
  }
}
</script>